import React from 'react';
import { useTranslation } from 'react-i18next';
import { BackgroundJobStatusEnum } from 'graphql-common';
import Chip from '@lib/components/Chip/Chip';
import getJobStatusChipProps from './getJobStatusChipProps';

type Props = {
  data: { status?: BackgroundJobStatusEnum | null; failed?: number | null };
};

export default function JobStatusChip(props: Props) {
  const { data } = props;
  const { status, failed } = data;
  const { t } = useTranslation();
  const { label, type } = getJobStatusChipProps({ status, failed, t });

  return <Chip type={type} label={label} />;
}
